var _polygon, _line, _circle, _rect, _circle2, _circle3, _rect2, _rect3, _line2, _line3, _line4, _line5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBespokeAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "50,5 90,27.5 90,72.5 50,95 10,72.5 10,27.5",
    fill: "none",
    stroke: "#000",
    strokeWidth: 4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 18,
    x2: 50,
    y2: 28,
    stroke: "#000",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 15,
    r: 4,
    fill: "#000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 28,
    width: 36,
    height: 30,
    rx: 5,
    fill: "none",
    stroke: "#000",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 40,
    r: 5,
    fill: "#000"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 40,
    r: 5,
    fill: "#000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 50,
    width: 20,
    height: 4,
    rx: 2,
    fill: "#000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 62,
    width: 28,
    height: 18,
    rx: 3,
    fill: "none",
    stroke: "#000",
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 38,
    x2: 32,
    y2: 38,
    stroke: "#000",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 68,
    y1: 38,
    x2: 72,
    y2: 38,
    stroke: "#000",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 48,
    x2: 32,
    y2: 48,
    stroke: "#000",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 68,
    y1: 48,
    x2: 72,
    y2: 48,
    stroke: "#000",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBespokeAi);
export default __webpack_public_path__ + "static/media/bespoke-ai.3e6314bb69952b2d08d303f7d9d544d4.svg";
export { ForwardRef as ReactComponent };